"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendOffSystemEvidenceNotificationOCRTypes = exports.SampleTypes = exports.OutcomeStatus = exports.OutcomeType = exports.sampleSchemaDef = exports.algoRerunDef = exports.RerunReasonsEnum = void 0;
const joi_1 = __importDefault(require("joi"));
const __1 = require("..");
const entry_1 = require("./entry");
const internal_1 = require("./internal");
const general_1 = require("./general");
var RerunReasonsEnum;
(function (RerunReasonsEnum) {
    RerunReasonsEnum["MARKS_GRADES"] = "MARKS_GRADES";
    RerunReasonsEnum["CONSORTIUM_ARRANGEMENTS"] = "CONSORTIUM_ARRANGEMENTS";
    RerunReasonsEnum["GROUP_DATA"] = "GROUP_DATA";
    RerunReasonsEnum["SPECIAL_CONSIDERATIONS"] = "SPECIAL_CONSIDERATIONS";
    RerunReasonsEnum["OTHER"] = "OTHER";
})(RerunReasonsEnum = exports.RerunReasonsEnum || (exports.RerunReasonsEnum = {}));
exports.algoRerunDef = {
    dateOfRerun: joi_1.default.string().required(),
    type: joi_1.default.string().valid(...Object.values(RerunReasonsEnum)),
    otherReason: joi_1.default.string().optional(),
    user: joi_1.default.string().required(),
};
exports.sampleSchemaDef = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { businessUnitId: joi_1.default.string().required(), componentNumber: joi_1.default.string().required(), componentName: joi_1.default.string(), samplingAlgorithm: joi_1.default.string().required(), maxMark: joi_1.default.number(), assessment: joi_1.default.object(internal_1.assessmentSchemaDef), qualificationName: joi_1.default.string(), seriesId: joi_1.default.number().required(), centreIds: joi_1.default.array(), fullSample: (0, __1.arraySchema)(entry_1.sampleEntryDef).default([]), subSample: (0, __1.arraySchema)(entry_1.sampleEntryDef), additionalSample: (0, __1.arraySchema)(entry_1.sampleEntryDef), highest: joi_1.default.object(entry_1.sampleEntryDef).required(), lowest: joi_1.default.object(entry_1.sampleEntryDef).required(), wholeSample: (0, __1.arraySchema)(entry_1.sampleEntryDef).default([]), manuallyAdded: (0, __1.arraySchema)(entry_1.sampleEntryDef), manuallyRemoved: (0, __1.arraySchema)(entry_1.sampleEntryDef), dateEdited: joi_1.default.string().required().optional(), algoRerunInfo: joi_1.default.object(exports.algoRerunDef).optional(), sampleCreationDate: (0, internal_1.dateSchema)().required(), totalEligibleCandidates: joi_1.default.number().required() });
var OutcomeType;
(function (OutcomeType) {
    OutcomeType["LOST_COURSEWORK"] = "Lost";
    OutcomeType["DAMAGED_COURSEWORK"] = "Damaged";
    OutcomeType["COURSEWORK_SHORTFALL"] = "Shortfall";
    OutcomeType["DISADVANTAGED"] = "Disadvantaged";
    OutcomeType["EXTENSION"] = "Extension";
    OutcomeType["ABSENT"] = "Absent";
})(OutcomeType = exports.OutcomeType || (exports.OutcomeType = {}));
var OutcomeStatus;
(function (OutcomeStatus) {
    OutcomeStatus["ACCEPTED"] = "Accepted";
    OutcomeStatus["REJECTED"] = "Rejected";
    OutcomeStatus["PENDING"] = "Pending";
    OutcomeStatus["PENDING_EVIDENCE"] = "Pending Evidence Required";
    OutcomeStatus["CANCELLED"] = "Cancelled";
    OutcomeStatus["REFERRED"] = "Referred";
})(OutcomeStatus = exports.OutcomeStatus || (exports.OutcomeStatus = {}));
var SampleTypes;
(function (SampleTypes) {
    SampleTypes["FULL"] = "Full";
    SampleTypes["SUB"] = "Sub";
    SampleTypes["ADDITIONAL"] = "Additional";
    SampleTypes["HIGHEST"] = "Highest";
    SampleTypes["LOWEST"] = "Lowest";
    SampleTypes["WHOLE"] = "Whole";
    SampleTypes["ADDED"] = "Added";
    SampleTypes["REMOVED"] = "Removed";
})(SampleTypes = exports.SampleTypes || (exports.SampleTypes = {}));
var SendOffSystemEvidenceNotificationOCRTypes;
(function (SendOffSystemEvidenceNotificationOCRTypes) {
    SendOffSystemEvidenceNotificationOCRTypes["CENTRE"] = "Centre";
    SendOffSystemEvidenceNotificationOCRTypes["CONSORTIUM"] = "Consortium";
})(SendOffSystemEvidenceNotificationOCRTypes = exports.SendOffSystemEvidenceNotificationOCRTypes || (exports.SendOffSystemEvidenceNotificationOCRTypes = {}));
